import { getCouponType } from "../analytics/helper";

export const getSavingsCornerClickStreamData = (title?: string, subtitle?: string, isPaymentCouponWidget?: boolean) => {
    return {
        headerString: title,
        subHeadString: subtitle,
        couponType: getCouponType(isPaymentCouponWidget),
    };
};
